import React from 'react';
import { motion, AnimatePresence } from 'motion/react';
import { ChevronRight } from 'lucide-react';
import { CardUI } from './CardUI';
import { useGameBoard } from './GameBoardContext';
import { SUIT_IMG_MAP } from '../lib/constants';
import { useSettings } from './SettingsContext';

export const CaptureComboModal: React.FC = () => {
  const {
    showCapturesMenu,
    selectedCard,
    possibleCaptures,
    onCaptureSelect,
    onDismissCapturesMenu,
  } = useGameBoard();

  const { playSfx, triggerHaptic } = useSettings();

  return (
    <AnimatePresence>
      {showCapturesMenu && selectedCard && (
        <motion.div
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          exit={{ opacity: 0 }}
          className="fixed inset-0 z-50 bg-black/80 overflow-y-auto"
        >
          <div className="min-h-full flex items-center justify-center p-4">
            <div className="glass-panel p-8 rounded-3xl max-w-2xl w-full my-8 shadow-2xl space-y-8">
            <div className="text-center space-y-2">
              <h2 className="text-3xl font-black italic uppercase tracking-tighter">Scegli come prendere</h2>
              <p className="text-white/60">Hai più combinazioni possibili con il tuo {selectedCard.value} di {selectedCard.suit}.</p>
            </div>

            <div className="flex justify-center gap-4">
              <CardUI card={selectedCard} disabled />
              <div className="flex items-center">
                <ChevronRight className="w-12 h-12 text-blue-500" />
              </div>
              <div className="grid grid-cols-2 gap-4">
                {possibleCaptures.map((cap, i) => (
                  <button
                    key={i}
                    onClick={() => {
                      playSfx('play');
                      triggerHaptic('light');
                      onCaptureSelect(cap);
                    }}
                    className="group bg-white/5 hover:bg-white/10 border border-white/10 p-4 rounded-2xl flex flex-col items-center gap-2 transition-all hover:scale-105 active:scale-95"
                  >
                    <div className="flex gap-1">
                      {cap.map(cc => (
                        <div key={cc.id} className="relative w-8 h-12 overflow-hidden rounded-md shadow-md">
                          <img
                            src={`/cards_optimized/${SUIT_IMG_MAP[cc.suit]}_${cc.value}.webp`}
                            alt={`${cc.value} of ${cc.suit}`}
                            className="absolute inset-0 w-full h-full object-contain"
                            draggable={false}
                            loading="lazy"
                            decoding="async"
                          />
                        </div>
                      ))}
                    </div>
                    <span className="text-[10px] uppercase font-bold text-blue-400">Usa questa combo</span>
                  </button>
                ))}
              </div>
            </div>

            <button
              onClick={() => {
                playSfx('click');
                onDismissCapturesMenu();
              }}
              className="w-full py-4 bg-white/5 hover:bg-white/10 rounded-xl text-white/40 uppercase text-xs font-bold tracking-widest transition-all"
            >
              Annulla mossa
            </button>
            </div>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
};
